import _get from 'lodash-es/get';

import {apiGetDocumentSection} from '@common/api/apiDocuments';
import {Composition} from '@common/types/documents/composition.types';
import {CompositionSections, CompositionSheetActions, CompositionSheetState} from '@common/types/stores/compositionSheetStore.types';
import {createCustomStore} from '@common/helpers/store/storeHelper';
import {getEndPoints} from '@common/stores/configStore';
import {Uuid} from '@common/types/index.types';
import JwtScope from '@common/constants/authentication/JwtScopeConstants';
import useAuthenticationStore from '@common/stores/authenticationStore';

const initialState: CompositionSheetState = {
  // Properties
  composition: null,
  // Status
  isLoading: false
};

const useCompositionSheetStore = createCustomStore<CompositionSheetState & CompositionSheetActions>('compositionSheet', set => ({
  ...initialState,

  fetchData: async (uuid: Uuid) => {
    const {scopedJwts, stsCredentials} = useAuthenticationStore.getState();
    const {apiDocuments} = getEndPoints();

    set(
      state => {
        state.isLoading = true;
      },
      undefined,
      'fetchData/pending'
    );

    const response = await apiGetDocumentSection({
      baseUrl: apiDocuments,
      credentials: stsCredentials,
      scopedJwt: _get(scopedJwts, [JwtScope.WEBAPP]),
      uuid,
      section: [CompositionSections.Information, CompositionSections.Energies, CompositionSections.Breadcrumb].join(','),
      additionalParamsUrls: {}
    });

    set(
      state => {
        state.composition = response;
        state.isLoading = false;
      },
      undefined,
      'fetchData/fulfilled'
    );
  },

  setComposition: (composition: Composition) => {
    set(
      state => {
        state.composition = composition;
      },
      undefined,
      'setComposition'
    );
  }
}));

export default useCompositionSheetStore;
